module.exports = __webpack_public_path__ + "img/biaoqian_suidao.a1454ca2.png";